export default {
  name: 'permission',
  mounted(el: HTMLElement, binding: any) {
    const currentRole = localStorage.getItem('current-role');
    if (!currentRole) {
      el.parentNode?.removeChild(el);
      return;
    }

    const role = JSON.parse(currentRole);
    const { value, arg } = binding;
    const roles = value.split(',').map((r: string) => r.trim());

    let hasPermission;
    if (arg === 'deny') {
      // 禁止模式：当前角色在禁止列表中则隐藏
      hasPermission = !roles.includes(role.roleKey);
    } else {
      // 允许模式：当前角色在允许列表中才显示
      hasPermission = roles.includes(role.roleKey);
    }

    if (!hasPermission) {
      el.parentNode?.removeChild(el);
    }
  }
};
